// extracted by css-extract-rspack-plugin
export default {"resizing":"Xex7Q","column":"NzkKL","footer":"sBxQA","preview":"HBgra","header":"kTOSA"};